import type { ReceiptPayload } from '../types';
import { getXpP203aLabelConfig } from '../xpP203aLabelConfig';
import { encodeReceiptPreviewToXpP203aTspl } from './tsplReceiptFromPreview';
import { buildTsplJob, buildTsplLabelHeaderLines, tsplTextLine } from './tsplEncode';

/** Minimal TSPL job to verify paper feed (LABEL mode). */
export function encodeXpP203aTsplTestPrint(): Uint8Array {
  const cfg = getXpP203aLabelConfig();
  return buildTsplJob([
    ...buildTsplLabelHeaderLines(cfg),
    tsplTextLine(20, 20, 'TEST PRINT', { font: '3', xMul: 1, yMul: 1 }),
    'PRINT 1,1',
  ]);
}

/** Harmless probe after opening the serial port (no label issued). */
export function encodeXpP203aTsplConnectProbe(): Uint8Array {
  const cfg = getXpP203aLabelConfig();
  return buildTsplJob([...buildTsplLabelHeaderLines(cfg)]);
}

/**
 * Map a receipt payload to a TSPL label job using the same layout as the on-screen preview.
 */
export function encodeReceiptToXpP203aTspl(receipt: ReceiptPayload): Promise<Uint8Array> {
  return encodeReceiptPreviewToXpP203aTspl(receipt);
}
